import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Global loading overlay state. Counter-based so concurrent triggers (e.g. a
 * route change plus a data fetch, or two overlapping fetches) compose without
 * one hiding the spinner while another is still running. The overlay
 * (app-loading-gk) is mounted once in AppComponent.
 */
@Injectable({
	providedIn: 'root',
})
export class LoadingGkService {
	private count = 0;
	private _isLoading = new BehaviorSubject<boolean>(false);

	get isLoading() {
		return this._isLoading.asObservable();
	}

	showLoading() {
		this.count++;
		if (this.count === 1) {
			this._isLoading.next(true);
		}
	}

	hideLoading() {
		this.count = Math.max(0, this.count - 1);
		if (this.count === 0) {
			this._isLoading.next(false);
		}
	}

	/** Runs a promise with the overlay shown while it's pending (hides on settle). */
	async wrap<T>(work: Promise<T>): Promise<T> {
		this.showLoading();
		try {
			return await work;
		} finally {
			this.hideLoading();
		}
	}
}
